export const INITIAL_DEALERS_REQUEST = "INITIAL_DEALERS_REQUEST";
export const FETCH_DEALERS_SUCCESS = "FETCH_DEALERS_SUCCESS";
export const INITIAL_DEALER_REQUEST = "INITIAL_DEALER_REQUEST";
export const FINAL_DEALER_REQUEST = "FINAL_DEALER_REQUEST";
